import { useRef, memo } from 'react';
import getComponentName from 'react-utils/getComponentName';
import { attachWrappedComponent } from './utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function (Component) {
  const ShareButtonComponent = /*#__PURE__*/memo(props => {
    const defaultRef = useRef(null);
    return /*#__PURE__*/_jsx(Component, Object.assign({}, props, {
      buttonRef: props.buttonRef || defaultRef
    }));
  });
  ShareButtonComponent.displayName = `ShareButton(${getComponentName(Component)})`;
  attachWrappedComponent(ShareButtonComponent, Component);
  return ShareButtonComponent;
}